<div class="dialog-header">
  <h2 mat-dialog-title>Hantera konflikt - Tåg {{ data.trainNumber }}</h2>
  <button mat-icon-button (click)="onCancel()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <!-- Train Info -->
  <div class="train-info-section">
    <div class="info-row">
      <span class="label">Sträcka:</span>
      <span class="value">{{ data.route.origin }} → {{ data.route.destination }}</span>
    </div>
    <div class="info-row">
      <span class="label">Tid:</span>
      <span class="value">{{ formatTime(data.route.departureAtUtc) }} – {{ formatTime(data.route.arrivalAtUtc) }}</span>
    </div>
    <div class="info-row">
      <span class="label">Driftdatum:</span>
      <span class="value">{{ data.trafficDate }}</span>
    </div>
  </div>

  <!-- Drivers Selection -->
  <div class="drivers-section">
    <h3>{{ isMultiGroup ? 'Välj förare per sträcka' : 'Välj förare som kör tåget' }}</h3>
    @if (isMultiGroup) {
      <p class="instruction">
        Avvikelsen täcker {{ driverGroups.length }} sträckor – gör ett val per sträcka.
      </p>
    }

    @for (group of driverGroups; track group; let i = $index) {
      <div class="route-group"
        [class.multi]="isMultiGroup">
        <!-- Route segment header (only shown when there are multiple groups) -->
        @if (isMultiGroup) {
          <div class="route-group-header">
            <mat-icon>route</mat-icon>
            <span class="route-label">{{ group.routeLabel }}</span>
            <span class="route-time">{{ group.timeLabel }}</span>
            <span class="group-status" [class.resolved]="group.selectedDriverId">
              <mat-icon>{{ group.selectedDriverId ? 'check_circle' : 'pending' }}</mat-icon>
            </span>
          </div>
        }
        <mat-radio-group
          [(ngModel)]="group.selectedDriverId"
          [name]="'driver-group-' + i"
          class="drivers-list">
          @for (driver of group.drivers; track driver) {
            <div
              class="driver-option"
              [class.selected]="isDriverSelected(group, driver)"
              [class.role-planned]="driver.role === 'PLANNED'"
              [class.role-deviating]="driver.role === 'DEVIATING'"
              (click)="selectDriver(group, driver)">
              <mat-radio-button
                [value]="driver.id"
                class="driver-radio">
              </mat-radio-button>
              <div class="driver-details">
                <div class="driver-header">
                  <span class="role-badge" [ngClass]="getRoleClass(driver.role)">
                    {{ getRoleLabel(driver.role) }}
                  </span>
                  <span class="driver-name">{{ driver.firstName }} {{ driver.lastName }}</span>
                </div>
                <div class="driver-meta">
                  @if (driver.employeeId) {
                    <span class="meta-item">
                      <mat-icon>badge</mat-icon>
                      {{ driver.employeeId }}
                    </span>
                  }
                  @if (driver.phoneNumber) {
                    <a
                      [href]="'tel:' + driver.phoneNumber"
                      class="meta-item phone-link"
                      (click)="$event.stopPropagation()">
                      <mat-icon>phone</mat-icon>
                      {{ driver.phoneNumber }}
                    </a>
                  }
                </div>
                <!-- Always show the driver's specific route so the dispatcher can see the exact segment -->
                @if (driver.route) {
                  <div class="driver-route">
                    <mat-icon>route</mat-icon>
                    <span>{{ driver.route.origin }} ({{ formatTime(driver.route.departureAtUtc) }}) → {{ driver.route.destination }} ({{ formatTime(driver.route.arrivalAtUtc) }})</span>
                  </div>
                }
              </div>
            </div>
          }
        </mat-radio-group>
      </div>
    }
  </div>

  <!-- Comment Section -->
  <div class="comment-section">
    <h3>Kommentar</h3>
    <mat-form-field appearance="outline" class="comment-field">
      <mat-label>Lägg till kommentar (valfritt)</mat-label>
      <textarea
        matInput
        [(ngModel)]="comment"
        placeholder="T.ex. 'Lokförare informerad', 'Sjukfrånvaro', etc."
        rows="3"
      maxlength="500"></textarea>
      <mat-hint align="end">{{ comment.length }}/500</mat-hint>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">
    Avbryt
  </button>
  <button
    mat-raised-button
    color="primary"
    class="save-button"
    (click)="onSave()"
    [disabled]="!canSave()">
    <mat-icon>check</mat-icon>
    Spara val
  </button>
</mat-dialog-actions>
